// @flow
import type { IdealistDayEvent as ApiIdealistDayEvent } from 'api/orgAdmin';
import type { Action } from '../../actions/orgDashboard/idealistDayEvents';

export type IdealistDayEvent = {
  ...$Exact<ApiIdealistDayEvent>,
  isFetching: boolean
};

export type State = {
  byId: {
    [string]: IdealistDayEvent
  }
};

export default function events(state: State = { byId: {} }, action: Action) {
  switch (action.type) {
    case 'ORG_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.eventId]: {
            ...state.byId[action.eventId],
            id: action.eventId,
            isFetching: true
          }
        }
      };
    case 'ORG_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_SUCCESS': {
      const { event } = action;
      const newState = {
        ...state,
        byId: {
          ...state.byId,
          [event.id]: {
            ...action.event,
            isFetching: false
          }
        }
      };
      return newState;
    }
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
